import { adapterReporteUsuarios } from 'adapters/adapterReporteUsuarios';
import * as types from 'constants/usersActionTypes';
import * as services from 'services/users.service';

export const getUsersList = () => async (dispatch) => {
  // dispatch({ type: types.GET_USERS_LOADING });
  try {
    const usuarios = await services.fetchUsers();
    dispatch({
      type: types.GET_USERS_SUCCESS,
      usuarios
    });
    return { success: true, usuariosResponse: usuarios };
  } catch (error) {
    return { success: false };
  }
};

export const getUsersNotRFAndAdmin = () => async (dispatch) => {
  try {
    const usuarios = await services.fetchUsersNotRFAndAdmin();
    dispatch({
      type: types.GET_USERS_SUCCESS,
      usuarios
    });
    return { success: true, usuariosResponse: usuarios };
  } catch (error) {
    return { success: false };
  }
};

export const getUsersNoDisposAsig = () => async () => {
  try {
    const response = await services.fetchUsersNoDisposAsig();
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const lockUser = (data) => async () => {
  try {
    const respuesta = await services.lockUser(data);
    return { success: true, response: respuesta };
  } catch (error) {
    return { success: false };
  }
};

export const getCatalogsToFormUsers = () => async () => {
  try {
    const respuesta = await services.fetchCatalogsFromSP();
    return { success: true, response: respuesta };
  } catch (error) {
    return { success: false };
  }
};

export const getUserLdap = (data) => async () => {
  try {
    const respuesta = await services.fetchUserLadp(data);
    return { success: true, response: respuesta };
  } catch (error) {
    return { success: false };
  }
};

export const postUser = (data) => async () => {
  try {
    const response = await services.postUser(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const editUserMonYEstReg = (data) => async () => {
  try {
    const response = await services.editUserSimac(data);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};

export const getReporteUsuarios = (params) => async (dispatch) => {
  console.log('response users.actions  ANTES: ', params);
  dispatch({ type: types.GET_USERS_LOADING });
  try {
    const response = await services.reporteUsuariosService(params);
    console.log('response users.actions: ', response);
    dispatch({
      type: types.GET_USERS_SUCCESS,
      payload: adapterReporteUsuarios(response.data)
    });
    return { success: true, response: response.data };
  } catch (error) {
    dispatch({ type: types.GET_USERS_FAILURE, error });
    return { success: false, response: error };
  }
};
